// 俄语
export default {
  day: 'день',
  hour: 'час',
  min: 'минута',
  sesc: 'секунда',
  cancel: 'отмена',
  confirm: 'подтвердить',
  showMore: 'показать больше',
  hideMore: 'скрыть',
  per_sale: { 
    title: 'Этап предпродажи заканчивается через {days} дней {hours} часов {mins} минут {secs} секунд',
    title1: 'Для участия в публичной продаже необходимо сначала пройти KYC',
    text: 'Купить DLC',
    text1: 'Пройти KYC',
  },
  meau: {
    nav1: 'Что такое DeepLink?',
    nav2: 'Как купить?',
    nav3: 'Белая книга',
    nav4: 'PITCH DECK',
    nav5: 'FAQ',
    nav6: 'Research',
    add: 'Адрес:',
    link: 'Подключить кошелек',
  },
  home: {
    intro: {
      title: 'DeepLink Public Sale',
      text: 'Обратный отсчет до первой фазы публичной продажи:',
      text1: 'Текущий KYC уже запущен',
      text2: 'Обратный отсчет до окончания фазы 5 публичной продажи',
      text3: 'Обратный отсчет до второй фазы публичной продажи:',
      tip: 'Пожалуйста, убедитесь, что вы завершили проверку KYC перед покупкой токенов (DLC)',
      tip1: 'Не покупайте повторно',
    },
    desc: {
      title: 'Deeplink состоит из двух компонентов: DeepLink Protocol и Deeplink Software',
      left: {
        text: 'Все платежи осуществляются с использованием токенов DeepLink!',
        text1: 'DeepLink Protocol — это децентрализованный протокол облачных игр с ИИ,',
        text2: 'который сочетает в себе технологии ИИ и блокчейн для обеспечения ультранизкой задержки в рендеринге игр. DeepLink Software — это программное обеспечение для удаленного управления играми и облачная игровая платформа, разработанная на основе DeepLink Protocol. Другие продукты, разработанные на основе DeepLink Protocol, включают платформу облачного интернет-кафе, блокчейн-облачную игровую консоль, портативную блокчейн-облачную игровую консоль и многое другое.',
        text3: '100% Secure & Verified',
        btn1: 'Введение в DeepLink Protocol',
        btn2: 'Введение в DeepLink Software',
      },
      right: {
        text1: 'Public Sale в процессе',
        text1_1: 'KYC в процессе',
        text1_2: 'Public Sale этап {pre_num1} в процессе',
        // text2: 'Цена DLC: 1DLC={price}USDT, осталось {days} дней {hour} часов {min} минут',
        text2: 'Цена DLC: 1DLC={price}USDT',
        text3: '{pre_num}-я Public Sale завершена',
        text4: 'Этап {pre_num1} скоро начнется',
        text5: 'Public Sale скоро начнется',
        text6: 'Пожалуйста, завершите процесс верификации KYC перед участием в публичной продаже. Спасибо за сотрудничество.',
        // text7: 'Дополнительное вознаграждение в размере 10% токенов на текущем этапе, вознаграждение снизится до 5% на следующем этапе',
        text7: 'Дополнительное вознаграждение в размере 5% токенов на текущем этапе, без дополнительного вознаграждения на следующем этапе',
        text8: 'Присоединяйтесь к сообществу и участвуйте в розыгрыше 10,000 USDT и DLC',
        process: 'Завершено {process}%',
        btn1: 'Принять участие в KYC верификации',
        btn1_1: 'KYC пройден',
        text7_1: 'KYC текущего кошелька на рассмотрении, пожалуйста, подождите',
        text7_2: 'KYC текущего кошелька пройден!',
        text7_3: 'KYC текущего кошелька не пройден, пожалуйста, подайте заново!',
        text7_4: 'KYC текущего кошелька не подан',
        btn2: 'Купить DLC TOKEN',
        btn3: 'Ссылка для рекомендаций 5%',
        btn3_1: 'Ссылка для рекомендаций 10%',
        btn3_2: 'Ссылка для рекомендаций 15%',
        btn3_3: 'Ссылка для рекомендаций 20%',
      },
      success: 'Ссылка скопирована в буфер обмена',
      error1: 'Пожалуйста, сначала подключите кошелек, чтобы получить эксклюзивный код приглашения и заработать награды',
      error2: 'Кошелек не подключен, пожалуйста, сначала подключите кошелек',
      error3: 'Верификация KYC в процессе, пожалуйста, дождитесь завершения перед покупкой',
      error4: 'Верификация KYC не удалась, пожалуйста, повторно отправьте информацию для верификации KYC для покупки',
      error5: 'Не удалось получить информацию для верификации KYC, пожалуйста, попробуйте позже',
      error6: 'Пожалуйста, дождитесь завершения обратного отсчета перед покупкой.',
      error7: 'Этап 3 завершен, пожалуйста, дождитесь начала Этапа 4',
      tip1: 'DLC еще не выдан',
      tip2: 'DLC был выдан на кошелек пользователя',
      tip3: 'Платеж успешен',
    },
    rule: {
      title: 'Описание правил',
      text1: 'Верификация KYC обязательна и требует предоставления документов, удостоверяющих личность, таких как удостоверение личности, паспорт или водительские права. Жители Сингапура, Китая, США, Южной Кореи и некоторых других стран не могут участвовать в IDO.',
      text2: 'После окончания публичной продажи DLC будет включен в листинг DEX-бирж в течение 7 дней и в листинг CEX-бирж в течение 15 дней. Адрес смарт-контракта токена DLC в сети BSC: 0xD610Be30b06A3828A27D608a38F1E85faAFdEDcC',
      text3: 'Покупка 20,000,000 DLC дает право на домашний игровой майнер DeepLink с GPU стоимостью 1500 долларов. Это предложение ограничено Японией и Европой, а детали доставки будут уведомлены по электронной почте.',
      text3_btn: 'Узнать больше о домашнем игровом майнере с GPU',
      text4: 'Публичная продажа будет закрыта через 48 часов после старта, цена каждого DLC составляет 0.003 USDT. 40% токенов останутся разблокированными, остальные 60% будут постепенно разблокированы с 31 августа 2024 года. Обратите внимание, что: 40% DLC будет переведено на указанный вами адрес кошелька через несколько минут после покупки, остальные 60% будут переведены на ваш кошелек после окончания срока блокировки.',
      text5: 'Public Sale будет проведена в 5 этапов,',
      table: {
        table1_text1: 'этап',
        table1_text2: '2024/06/05-06/07',
        table1_text3: '2024/06/09-06/29',
        table1_text4: '2024/06/29-07/13',
        table1_text5: '2024/07/13-08/05',
        table1_text6: '2024/08/05-09/11',
        table2_text1: 'Количество DLC',
        table2_text2: '350,000,000DLC',
        table2_text3: '400,000,000DLC',
        table2_text4: "300,000,000DLC",
        table2_text5: '450,000,000DLC',
        table2_text6: 'TBA',
        table3_text1: 'Цена DLC (USDT)',
        table3_text2: '0.003',
        table3_text3: '0.003',
        table3_text4: '0.003',
        table3_text5: '0.003',
        table3_text6: '0.003',
        table4_text1: 'Бонус',
        table4_text2: 'Дополнительный бонус 20% DLC',
        table4_text3: 'Дополнительный бонус 15% DLC',
        table4_text4: 'Дополнительный бонус 10% DLC',
        table4_text5: 'Дополнительный бонус 5% DLC',
        table4_text6: 'NO',
        table5_text1: 'Количество',
        table5_text2: '1,050,000 USDT',
        table5_text3: '1,200,000 USDT',
        table5_text4: '900,000 USDT',
        table5_text5: '1,350,000 USDT',
        table5_text6: 'TBA'
      }
    },
    ecology: {
      title: 'Обзор экосистемы DeepLink Protocol',
      block1_title: 'Программное обеспечение DeepLink',
      block1_text1: 'Основная функция программного обеспечения DeepLink — удаленное управление и платформа облачных игр',
      block1_text2: 'DeepLink Protocol включает в себя DeepLink Protocol и DeepLink Software. В основе DeepLink Software лежат функции удаленного управления и облачных игр, что позволяет пользователям участвовать в удаленных играх, удаленной работе и получать доступ к облачным игровым сервисам. В настоящее время это программное обеспечение имеет пользовательскую базу в 110 странах, более 400 000 загрузок и более 200 000 созданных кошельков по всему миру.',
      block1_btn1: 'Узнать больше о программном обеспечении DeepLink',
      block2_title: 'Облачные интернет-кафе и облачные киберспортивные площадки',
      block2_text1: 'Облачное интернет-кафе представляет собой инновационную модель интернет-кафе и киберспортивных сервисов, использующую технологию рендеринга с ультранизкой задержкой DeepLink Protocol.',
      block2_text2: 'В этой конфигурации игры и приложения размещены на облачных серверах GPU, а не на локальных компьютерах, что позволяет пользователям получать доступ к играм и играть через облачные сервисы без необходимости в высокопроизводительной локальной GPU-станции. Облачные интернет-кафе на основе технологии DeepLink развертываются в нескольких странах, включая Южную Корею, Китай, Японию, Вьетнам, Филиппины и Индию, при участии HYCONS, ZESTCLOUD, GLOWSTEAM и TIKEREN. Уже существует рабочий пример в Южной Корее.',
      block2_btn1: 'Посмотреть видео',
      block2_btn2: 'Узнать больше об облачных интернет-кафе',
      block3_title: 'Блокчейн-облачная игровая консоль',
      block3_text1: 'Что такое облачная игровая консоль?',
      block3_text2: 'Блокчейн-облачная игровая консоль представляет собой прорыв в игровой аппаратуре, предлагая высокую частоту обновления кадров (FPS) для бесперебойного киберспортивного игрового опыта. Разработанная группой HKC, облачная игровая консоль TIKEREN использует технологию рендеринга с ультранизкой задержкой DeepLink и подключается в реальном времени к облачным серверам GPU для повышения производительности рендеринга игр.',
      block3_btn1: 'Узнать больше о блокчейн-облачной игровой консоли',
      block4_title: 'Блокчейн-облачная портативная игровая консоль',
      block4_text1: 'Что такое облачная портативная игровая консоль?',
      block4_text2: 'Блокчейн-облачная портативная игровая консоль, основанная на технологии рендеринга с ультранизкой задержкой DeepLink, предлагает более экономичный вариант по сравнению с традиционными портативными консолями, обеспечивая при этом плавный игровой опыт уровня AAA. Подключаясь к облачным серверам GPU для рендеринга игр в реальном времени, она снижает стоимость портативной консоли на 70%.',
      block4_btn1: 'Узнать больше о блокчейн-облачной портативной игровой консоли',
    },
    coverage: {
      title: 'Карта глобального распределения пользователей программного обеспечения DeepLink',
      text: 'Общее количество пользователей DeepLink:'
    },
    track: {
      title: 'DeepLink Protocol - это сочетание DePIN+AI+Game',
      text: 'Относится к самым популярным направлениям текущей блокчейн-индустрии',
      block1_title: 'Каков размер рынка DeepLink?',
      block1_text: 'Одну из функций DeepLink можно понимать как децентрализованную версию XBOX и PlayStation. К концу 2023 года мировые продажи PS5 от Sony достигли 50 миллионов единиц, а Xbox Series X|S достигли 30 миллионов единиц. Общие продажи PS и Xbox превысили 200 миллионов единиц, что показывает огромный рынок для высококлассных AAA-игр.',
      block2_title: 'DeepLink, как и XBOX и PlayStation, также обслуживает игроков в высококлассные AAA-игры, но его бизнес-модель совершенно другая',
      block2_text: 'Игрокам DeepLink не нужно покупать высококлассные игровые консоли. Им нужно только скачать программное обеспечение DeepLink или купить облачную игровую консоль на базе блокчейна или портативную облачную игровую консоль на базе блокчейна. Игроки могут наслаждаться AAA-игровым опытом, аналогичным XBOX и PlayStation, но экономят 80% стоимости оборудования.',
      block3_title: 'Майнеры предоставляют высококлассные игровые консоли AAA, которые являются системами Windows и совместимы со всеми AAA-играми Windows.',
      block3_text: 'Игровые консоли майнеров могут быть дома или в дата-центрах. Консоли Xbox и PlayStation могут использоваться только их владельцами и не могут быть сданы в аренду другим, что приводит к низкой эффективности использования и большому расходу ресурсов. Игровая майнинг-машина DeepLink может быть предоставлена в пользование любому, что повышает использование аппаратных ресурсов и создает новую бизнес-модель.',
      block4_title: 'Майнеры, предоставляющие игровые майнинг-машины, могут получать вознаграждения в токенах DLC',
      block4_text: 'Это стимулирует большее количество майнеров предоставлять игровые майнинг-машины. Пользователи должны платить токенами DLC за покупку игрового времени, что расширяет сценарии использования DLC и увеличивает количество держателей токенов. Потенциальный размер рынка пользователей превышает 1 миллиард человек.',
      table: {
        table1_text1: 'Детальное сравнение',
        table1_text2: 'Deep Link',
        table1_text3: 'Xbox',
        table1_text4: 'PS5',
        table2_text1: 'Играть в AAA-игры',
        table2_text2: 'Пользователям не нужно покупать оборудование, достаточно скачать программное обеспечение DeepLink',
        table2_text3: 'Пользователи должны покупать оборудование',
        table2_text4: 'Пользователи должны покупать оборудование',
        table3_text1: 'Игровая консоль',
        table3_text2: 'Можно сдавать в аренду и зарабатывать $DLC, можно сдавать в аренду более 12 часов в день, окупаемость за 10 месяцев',
        table3_text3: 'Может использоваться только владельцем, нельзя сдавать в аренду, используется 2-4 часа в день, ресурсы оборудования тратятся впустую',
        table3_text4: 'Может использоваться только владельцем, нельзя сдавать в аренду, используется 2-4 часа в день, ресурсы оборудования тратятся впустую',
        table4_text1: 'Портативная консоль',
        table4_text2: 'Поддерживается, можно подключить к любому оборудованию',
        table4_text3: 'Нет выделенной портативной консоли',
        table4_text4: 'Поддерживается, можно подключить только к PS5',
        table5_text1: 'Облачная игровая консоль',
        table5_text2: 'Поддерживается',
        table5_text3: 'Не поддерживается',
        table5_text4: 'Не поддерживается',
        table6_text1: 'Облачный интернет-кафе',
        table6_text2: 'Поддерживается',
        table6_text3: 'Не поддерживается',
        table6_text4: 'Не поддерживается',
      },
      btn1: 'DeepLink Software',
      btn2: 'DeepLink Protocol',
      btn3: 'Представление команды',
      btn4: 'Экономическая модель'
    },
    faqs: {
      title: 'FAQS',
      text: 'Возможно, у вас есть вопросы, у нас есть ответы.',
      ques_title1: '1. Что такое Public Sale?',
      ques_text1: 'Во время Public Sale будет продано ограниченное количество токенов по установленной цене людям, желающим участвовать на раннем этапе. Это отличная возможность стать частью DeepLink до фактического запуска токена. Участвуя в Public Sale, вы можете купить токены по ранней цене до их публичного предложения. Таким образом, Public Sale можно рассматривать как потенциальную возможность приобрести токены до того, как они войдут в обращение и будут размещены на биржах.',
      ques_title2: '2. Почему мы проводим Public Sale?',
      ques_text2_1: 'Мы проводим Public Sale для создания сильного сообщества держателей $DLC, улучшения нашей платформы и привлечения средств для привлечения большего количества игроков в нашу экосистему.',
      ques_text2_2: 'Средства, собранные во время Public Sale, будут постоянно реинвестироваться в продукты DeepLink, вводя новые функции и расширяя пользовательскую базу через маркетинговые мероприятия. Это позволит нам реализовать нашу маркетинговую стратегию до выпуска токена $DLC.',
      ques_text2_3: 'Наша цель - привлечь 1.000.000.000 человек к использованию DeepLink, что предоставит широкие возможности для использования токена $DLC и обеспечит долгосрочный успех токена $DLC. Токен $DLC будет размещен на биржах DEX и CEX, что будет способствовать дальнейшему росту экосистемы DeepLink.',
      ques_text2_4: 'Присоединяйтесь к Public Sale DeepLink и станьте частью DeepLink уже сейчас!',
      ques_title3: '3. В чем разница между DeepLink Protocol и DeepLink Software?',
      ques_text3_1: 'DeepLink Protocol — это децентрализованный AI-протокол облачных игр, который сочетает в себе технологии AI и блокчейн для обеспечения ультранизкой задержки рендеринга игр.',
      ques_text3_2: 'DeepLink Software — это программное обеспечение для удаленного управления играми и облачная игровая платформа, разработанная на основе DeepLink Protocol.',
      ques_text3_3: 'Другие продукты, разработанные на основе DeepLink Protocol, включают платформу облачных киберспортивных кафе, блокчейн-облачную игровую консоль и блокчейн-облачную портативную игровую консоль и другие.',
      ques_title4: '4. В чем инновация DeepLink Protocol?',
      ques_text4: 'DeepLink решает ключевые проблемы, с которыми сталкивается индустрия облачных игр, с помощью технологий блокчейн и AI, привлекая майнеров и неиспользуемые GPU-машины через механизм токен-инцентивов. Он также привлекает неиспользуемую пропускную способность для решения двух основных проблем индустрии облачных игр. Технология AI улучшает качество графики в играх, улучшая пользовательский опыт.',
      ques_title5: '5. Что такое $DLC Token?',
      ques_text5: '$DLC Token — это единственное средство оплаты в экосистеме DeepLink. Пользователи должны платить $DLC Token за покупку времени облачных игр, аренду облачных игровых компьютеров, покупку лицензий и другие услуги.',
      ques_title6: '6. Кто является целевой аудиторией DeepLink Protocol?',
      ques_text6_1: '1) Компании-разработчики игр AAA: Помогает преобразовать игры AAA в облачные игры, позволяя им работать на любом низкопроизводительном устройстве, включая мобильные телефоны, увеличивая базу пользователей игр AAA более чем в 10 раз.',
      ques_text6_2: '2) Интернет-кафе и отели для киберспорта: Помогает модернизировать традиционные интернет-кафе, превращая их в облачные интернет-кафе, снижая инвестиции в оборудование более чем на 80% и увеличивая чистую прибыль в 3 раза за 4 года.',
      ques_text6_3: '3) Производители оборудования для облачных игровых консолей: Производители могут интегрировать DeepLink Protocol, что позволяет играть в игры AAA с низкопроизводительным процессором и высококачественным игровым дисплеем, экономя игрокам 80% затрат на оборудование.',
      ques_text6_4: '4) Производители портативных облачных игровых консолей: Производители могут интегрировать DeepLink Protocol, что делает цену портативной консоли на 30% ниже цены традиционной консоли, с игровой производительностью более чем в 5 раз выше, чем у традиционной портативной консоли.',
      ques_title7: '7. Кто является целевой аудиторией DeepLink Software?',
      ques_text7: 'Это 3 миллиарда потенциальных игроков по всему миру, которые могут наслаждаться высококачественными играми AAA на своих мобильных телефонах, маломощных компьютерах или Mac и телевизорах.',
      ques_title8: '8. Есть ли период вестинга?',
      ques_text8: '40% купленных DLC токенов не заблокированы, 60% будут разблокированы в течение 150 дней, начиная с 31 августа 2024 года, с разблокировкой 10% каждые 30 дней.',
      ques_title9: '9. Как купить $DLC?',
      ques_text9: 'Сначала пройдите KYC, предоставьте свою личную информацию и, после одобрения, вы сможете участвовать в покупке $DLC, когда начнется Public Sale.',
    },
    buy: {
      title: 'Как купить?',
      step1: 'Шаг 1:',
      step1_text: 'Подключите ваш Metamask или Trust Wallet',
      step2: 'Шаг 2:',
      step2_text: 'Подтвердите транзакцию. Вы можете использовать USDT для покупки $DLC',
      step3: 'Шаг 3:',
      step3_text: 'Вы можете получить свой $DLC после окончания публичной продажи',
      btn1: 'Нужна помощь',
      btn2: 'Купить DLC',
    },
    potential: {
      title: 'Growth Potential', 
      text1_1: 'Рыночная капитализация нескольких токенов в секторе DePIN продолжает расти после их листинга на биржах.',
      text1_2: '$ 888',
      text1_3: '$ 2288',
      text1_4: '$ 5888',
      text1_5: '$ 12888',
      text2: 'Потенциальная аудитория пользователей DeepLink Software превышает 1 миллиард человек, что приведет к переходу большого количества пользователей web2 в мир web3. Потенциальное число держателей $DLC превышает 1 миллиард человек.',
      text3: 'В мире насчитывается более 200 000 киберспортивных интернет-кафе. В будущем более 50% традиционных интернет-кафе будут преобразованы в облачные интернет-кафе. Технология облачных интернет-кафе имеет широкий потенциал применения, и каждое облачное интернет-кафе будет использовать $DLC для платежей, что приведет к массовому использованию $DLC.',
      text4: 'Опираясь на данные о продажах XBOX и PS5, число пользователей, покупающих блокчейн-облачные игровые консоли и портативные блокчейн-облачные игровые консоли, превысит 100 миллионов, что принесет $DLC огромную ценность.'
    },
    report: {
      title: 'Медиа-отчеты о DeepLink'
    },
    prompt: {
      title: 'Информационное уведомление',
      text1: 'DeepCloudX.PTE.LTD управляет веб-сайтом deeplink.cloud ("платформа").',
      text2: 'Используя эту платформу, вы принимаете наши условия обслуживания, политику конфиденциальности, политику в отношении файлов cookie и соглашение о продаже токенов DLC. В вашей юрисдикции криптовалюты могут не регулироваться. Стоимость криптовалют может расти или падать. Прибыль может быть подвержена налогообложению на прирост капитала или другим налогам, применимым в вашей юрисдикции. Ничто на этом веб-сайте не должно толковаться как предложение или рекомендация по покупке, продаже или инвестированию. Вы несете полную ответственность за определение того, подходит ли вам любая покупка или связанная с ней транзакция, исходя из ваших личных целей, финансового состояния и допустимого уровня риска.',
      text3: 'Вам следует обратиться за консультацией к надежным лицензированным юристам и консультантам для получения юридических, налоговых, страховых или бизнес-консультаций. DLC не гарантирует никаких результатов, доходов или возврата капитала для любой криптовалюты на этом веб-сайте. Получая доступ к этому веб-сайту и любым его страницам, вы соглашаетесь с условиями соглашения о продаже DLC. Покупка криптовалют связана с рисками и может привести к частичным или полным убыткам.'
    }
  },
  dialog1: {
    title: 'Предоставить информацию для KYC',
    text1: 'Загрузить информацию о личности:',
    text2: 'Загрузить фото с удостоверением личности:',
    text3: 'Лицевая сторона удостоверения личности, паспорта или водительских прав',
    text4: 'Лицо и информация о личности должны быть четко видны',
    text5: 'Количество DLC, которое вы хотите купить:',
    text6: 'Сертифицированный адрес кошелька:',
    text7: 'Вы получите вознаграждение в размере 1000 DLC после прохождения верификации KYC, и заблокированные во время Public Sale DLC также будут отправлены на этот адрес кошелька',
    text7_1: 'Только этот адрес может быть использован для покупки DLC после верификации KYC, адрес биржи не допускается',
    text8: 'Где создать адрес кошелька DLC в сети DBC?',
    text9: 'Или',
    text10: 'Введите адрес электронной почты:',
    text11: 'Получить код подтверждения',
    text12: 'Введите код подтверждения:',
    text13: 'Повторная отправка через {secs} секунд',
    text14: '(Максимум 20,000,000 DLC, вы можете купить только количество, одобренное при верификации KYC, когда начнется Public Sale)',

    success1: 'Код подтверждения отправлен!',
    success2: 'Информация успешно отправлена, ожидается проверка',
    error1: 'Вы должны выбрать файл изображения!',
    error2: 'Файл изображения не может быть пустым!',
    error3: 'Имя пользователя не может быть пустым!',
    error4: 'Адрес кошелька не может быть пустым!',
    error5: 'Электронная почта не может быть пустой!',
    error6: 'Пожалуйста, введите правильный адрес электронной почты!',
    error7: 'Код подтверждения не может быть пустым!',
    error8: 'Ошибка отправки кода подтверждения, попробуйте позже!',
    error9: 'Ошибка добавления',
    error10: 'Неверный код подтверждения, попробуйте снова',
    error11: 'Ошибка при запросе информации по электронной почте',
    error12: 'Количество покупки не может превышать 20,000,000',
    error13: 'Код подтверждения истек, получите новый',
    error14: 'Информация успешно отправлена, ошибка отправки подтверждающего письма',
    error15: 'Если вы не получили письмо, проверьте папку со спамом',
    error16: 'Размер изображения не должен превышать 5 МБ',
    error17: 'Пожалуйста, не отправляйте данные для KYC повторно',
    tip1: '(Дружественное напоминание: Личная информация используется только для KYC и не для других целей)',
  },
  dialog2: {
    title: 'Купить DLC',
    text1: 'Количество DLC для покупки:',
    text2: 'Необходимо приобрести не менее 150,000 DLC',
    text3: 'Выберите криптовалюту для оплаты:',
    text4: 'Введите адрес кошелька DLC в сети DBC:',
    text5: '40% DLC будут переведены на этот адрес кошелька в течение нескольких минут, оставшиеся 60% DLC будут переведены на этот адрес кошелька по истечении срока блокировки',
    text6: 'Где создать адрес кошелька DLC в сети DBC?',
    text7: 'Или',
    text8: 'Эквивалент в USDT:',
    text9: 'Выберите способ оплаты:',
    text9_1: 'Оплатить с текущего подключенного кошелька',
    text9_2: 'Оплатить с помощью QR-кода',
    error1: 'Количество DLC не может быть пустым',
    error2: 'Пожалуйста, введите число',
    error3: 'Введенное число должно быть больше 50,000',
    error4: 'Адрес кошелька не может быть пустым',
    error5: 'Ошибка создания заказа',
    success1: 'Оплата прошла успешно, DLC будут переведены на ваш адрес кошелька в течение нескольких минут, пожалуйста, проверьте!',
    success2: 'Оплата прошла успешно по ссылке перенаправления, DLC будут переведены на ваш адрес кошелька в течение нескольких минут, пожалуйста, проверьте!',
    error6: 'Количество USDT не может быть пустым',
    error7: 'Количество USDT не может быть меньше 150',
    error8: 'Количество USDT не может быть больше 60,000',
    error9: 'Сумма платежа не совпадает с предварительно введенной суммой, пожалуйста, свяжитесь с администратором для подтверждения правильности',
  },
  dialog3: {
    title: 'Введение в All-in-One устройство',
    text1: '1. Что такое облачная игровая all-in-one консоль?',
    text2: 'Облачная игровая all-in-one консоль по сравнению с традиционными all-in-one устройствами имеет дисплей с высокой частотой обновления кадров (FPS), обеспечивая плавный игровой опыт. Облачная игровая консоль TIKEREN от HKC Group разработана на базе технологий DeepBrainChain + DeepLink и может в реальном времени подключаться к мощным удаленным GPU для рендеринга и расчета игр. Устройство оснащено встроенной системой Windows и может использоваться для обычной работы и развлечений, позволяя стримить игры с вашего собственного высокопроизводительного GPU через DeepLink. Когда у вас нет мощного GPU, вы можете подключиться к удаленному мощному GPU через DeepLink для игры в AAA-игры, оплачивая определенное количество DLC токенов в час.',
    text3: '2. Демонстрация консоли TIKEREN',
    table: {
      th: {
        text1: 'Проект',
        text2: '27 дюймов',
        text3: '31.5 дюймов',
      },
      td1: {
        text1: 'Mode Type',
        text2: 'MA27H13QC1',
        text3: 'MA27H13QC1'
      },
      td2: {
        text1: 'Color Category',
        text2: 'Black',
        text3: 'Black'
      },
      td3: {
        text1: 'Display Size',
        text2: '27 дюймов',
        text3: '31.5 дюймов',
      },
      td4: {
        text1: 'Aspect Ratio',
        text2: 'Wide (16:9)',
        text3: 'Wide (16:9)'
      },
      td5: {
        text1: 'Panel Type',
        text2: 'IPS',
        text3: 'VA'
      },
      td6: {
        text1: 'Panel Resolution',
        text2: 'QHD 2560*1440',
        text3: 'QHD 2560*1440'
      },
      td7: {
        text1: 'Panel Refresh Rate',
        text2: '180Hz (Max)',
        text3: '170Hz(Max)'
      },
      td8: {
        text1: 'Responese Time',
        text2: '1mS(MPRT) GTG 1ms',
        text3: '1ms(MPRT) GTG 1ms'
      },
      td9: {
        text1: 'Color Gamut',
        text2: 'DCIP3 90%',
        text3: 'DCIP3 90%'
      },
      td10: {
        text1: 'Mainboard Solution',
        text2: 'Intel® N100 Chipset',
        text3: 'Intel® N100 Chipset'
      },
      td11: {
        text1: 'CPU/Cooler',
        text2: 'Intel N100 3.4GHz',
        text3: 'Intel N100 3.4GHz'
      },
      td12: {
        text1: 'Memory',
        text2: 'DDR4 8GB(Option Max 32G)',
        text3: 'DDR4 8GB(Option Max 32G)'
      },
      td13: {
        text1: 'Hard Disk',
        text2: 'SSD 128G(Option Max 1T)',
        text3: 'SSD 128G(Option Max 1T)'
      },
      td14: {
        text1: 'OS',
        text2: 'Windows 10/11(0ption)',
        text3: 'Windows 10/11(0ption)'
      },
      td15: {
        text1: 'GPU',
        text2: 'Intel UHD Graphics',
        text3: 'Intel UHD Graphics'
      },
      td16: {
        text1: 'Rear Interface',
        text2: '1*DC Power Connector，1*RJ45(2.5G)，4* USB 3.0，1*Audio jacks',
        text3: '1*DC Power Connector，1*HDMIN，1*HDMI OUT，1*RJ45(2.5G)，4* USB 3.0,1*Audio iacks'
      },
      td17: {
        text1: 'Side Interface',
        text2: 'USB 2.0x2，Power Button x1',
        text3: 'USB 2.0x2，Power Button x1'
      },
      td18: {
        text1: 'Wi-Fi',
        text2: '2.4G~5GHz(Wi-Fi5)，BT(4.2)',
        text3: '2.4G~5GHz(Wi-Fi5)，BT(4.2)'
      },
      td19: {
        text1: 'Audio',
        text2: 'Built-in Speakers*2',
        text3: 'Built-in Speakers*2'
      },
      td20: {
        text1: 'Base/Stand',
        text2: 'HAS:VESA',
        text3: 'HAS:VESA'
      },
      td21: {
        text1: 'Pivot',
        text2: 'Вверх, вниз, влево, вправо, поворот на 90°, регулировка по высоте',
        text3: 'Вверх, вниз, влево, вправо, поворот на 90°, регулировка по высоте',
      },
      td22: {
        text1: 'Power',
        text2: '90W',
        text3: '90W'
      },
      td23: {
        text1: 'Game Screen lmprovement',
        text2: 'Free Sync, G-Sync',
        text3: 'Free Sync, G-Sync'
      }
    },
    btn: 'Понял'
  },
  dialog4: {
    title: 'Введение в портативную облачную игровую консоль',
    text1: '1. Что такое портативная облачная игровая консоль?',
    text2: 'Портативная облачная игровая консоль отличается от традиционных портативных консолей тем, что разработана на основе технологии рендеринга с ультранизкой задержкой от DeepLink. Это позволяет в реальном времени подключаться к облачным GPU-серверам для высокопроизводительного рендеринга игр, снижая стоимость портативной консоли на 70% и обеспечивая плавный игровой опыт в играх AAA-класса. Портативная консоль имеет встроенный Google Play для загрузки Android-игр и также позволяет стримить игры с вашей собственной высокопроизводительной Windows GPU/PS/XBOX. Если у вас нет высокопроизводительной GPU, вы можете подключиться к удаленной высокопроизводительной GPU через DeepLink для игры в AAA-игры, оплачивая определенное количество DLC-токенов в час.',
    text3: '2. Демонстрация блокчейн-облачной игровой консоли',
    btn: 'Понял'
  },
  dialog5: {
    title: 'Введение в домашнюю GPU-игровую майнинговую машину',
    text1: '1. Что такое домашняя GPU-игровая майнинговая машина?',
    text2: 'GPU-игровая майнинговая машина оснащена графическим процессором NVIDIA 4070 Super, процессором Intel i7-13700F, 32 ГБ оперативной памяти и 2 ТБ SSD. Встроенное программное обеспечение для майнинга и система управления DeepLink позволяют любому человеку установить эту машину дома и зарабатывать вознаграждения в DLC. Ежегодно 1 миллиард токенов DLC распределяются в качестве вознаграждений всем игровым майнинговым машинам, независимо от того, арендуют ли пользователи машину для игр. При настройке машины на аренду GPU можно получать вознаграждения в DLC и доход от аренды в DBC. Когда машину не арендуют, можно майнить другие токены, что обеспечивает круглосуточный доход.',
    text3: '2. Демонстрация домашней GPU-игровой майнинговой машины',
    text4: '3. Технические характеристики',
    text5_1: 'With RTX4070 Super Graphics Card',
    text5_2: 'Core i7-13700F, 16 Cores, 24 Threads, Base 1.5/2.1 GHz, Max 4.1/5.1GHz;',
    text5_3: 'Graphics Card GeForce RTX4070 Supe12G. Support 3rd Gen Ray Tracing and 4th Tensor Core.',
    text5_4: 'RAM Dual DDR4, Max 64GB (32GB*2).',
    text5_5: 'Hard Drive Ports One M2 2280 NVME SSD, and support to add double 2.5" SATA hard drive.',
    text5_6: 'Ports 4*USB 3.2, 4* USB 2.0, 3*DisplayPort, 1*HDMI, 2*LAN, 1*Optical, 1*Audio, 1*DC-IN, 2*WiFi ports.',
    text5_7: 'Operating System Preinstall with Windows 11 Pro.',
    btn: 'Понял'
  }
}